var r=function(){return[]};export{r as default};
//# sourceMappingURL=stubArray.js.map
